// English translation for the Temps module
export const locale = {
  lang: 'en',
  data: {
    TEMPS: {
      ALL_ENTRIES_ALREADY_EXIST: 'The specified times have already been declared for this user on these dates',
      SOME_ENTRIES_ALREADY_EXIST: 'Some times were ignored because they were already declared',
      TIME_ALREADY_EXISTS: 'This time already exists for this user on this date',
      FORFAIT_JOURS_SINGLE_DECLARATION: 'Declaration for this day already exists',
      MODAL_SUBTITLE: 'Declare your working hours',
      EDIT_MODAL_SUBTITLE: 'Edit the details of your declaration',
      EDIT_DECLARATION: 'Edit declaration',
      EDIT_SUCCESS: 'Declaration updated successfully',
      HORAIRES: 'Schedule',
      DESCRIPTION_PLACEHOLDER: 'Describe the work done...',
      PROJET: 'Project',
      SELECT_PROJECT: 'Select a project...',
      AUCUN: 'None',
      HOURS: 'hours',
      HOUR: 'hour',
      MINUTES: 'minutes',
      MINUTE: 'minute',
      AND: 'and',
      PERIODE: 'Period',
      JOURNEE_ENTIERE: 'Full day',
      MATINEE: 'Morning',
      APRESMIDI: 'Afternoon',
      ALERT_MODAL_SUBTITLE: 'Report a problem or situation requiring special attention',
      COMMENTAIRE: 'Comment',
      ALERT_COMMENT_PLACEHOLDER: 'Describe the problem or situation...',
      ENVOYER_ALERTE: 'Send alert',
      ALERT_ENVOYEE_SUCCESS: 'Alert sent successfully',
      DECLARE_ALERT: 'Declare Alert',
      ALERT_MESSAGE: 'Alert Message',
      ALERT_MESSAGE_PLACEHOLDER: 'Write your alert message here...',
      ALERT_MESSAGE_REQUIRED: 'Alert message is required',
      ALERT_SAVED_SUCCESS: 'Alert saved successfully',
      VALIDER_SEMAINE: 'Validate entire week',
      SEMAINE_DU: 'Week of',
      AU: 'to',
      CONFIRM_VALIDER_SEMAINE: 'Do you want to validate all pending days for this week?',
      VALIDATION_SEMAINE_SUCCESS: 'Week validated successfully',
      DECLARER_SEMAINE: 'Declare a week',
      DECLARE_WEEK_TITLE: 'Declare a week',
      DECLARE_WEEK_SUBTITLE: 'Declare an entire week in a few clicks',
      DELEGATED_MANUAL_TEMPLATE: 'Declare time for one collaborator using a manual template. Usual schedules are not loaded and existing declared days are preserved.',
      DELEGATED_LOAD_ERROR: 'Unable to load data. Declaration remains blocked. Select the collaborator again to retry.',
      DELEGATED_CALENDAR_UNAVAILABLE: 'This collaborator\'s leave calendar is unavailable within your authorized scope. Declaration is blocked.',
      DELEGATED_INVALID_PERIOD: 'Enter a valid period with an end date on or after the start date.',
      DELEGATED_INVALID_HOURS: 'Finish editing and check the times: start before end, with both break times strictly within the working day.',
      SEMAINE_DE_REFERENCE: 'Week containing',
      JOURS_A_DECLARER: 'Days to declare',
      AUCUN_JOUR_SELECTIONNE: 'Please select at least one day',
      JOURS_DECLARES_SUCCESS: 'day(s) successfully declared',
      JOURS_DECLARATION_ECHEC: 'day(s) already declared or failed',
      SELECTIONNER_PERIODE: 'Select a period',
      HORAIRES_PAR_DEFAUT: 'Default hours',
      HORAIRES_PAR_DEFAUT_SUBTITLE: 'Apply the same hours to the selected days',
      DEBUT_JOURNEE: 'Start of day',
      DEBUT_PAUSE: 'Break start',
      FIN_PAUSE: 'Break end',
      FIN_JOURNEE: 'End of day',
      APPLIQUER_A: 'Apply to',
      APPLIQUE_A_JOURS: 'Applied to {{count}} days',
      REINITIALISER: 'Reset',
      COPIER_SUR_LA_SEMAINE: 'Copy to the week',
      APERCU_SEMAINE: 'Week preview',
      JOUR: 'Day',
      STATUT: 'Status',
      HORAIRES_DE_TRAVAIL: 'Working hours',
      PAUSE: 'Break',
      TOTAL: 'Total',
      ACTION: 'Action',
      STATUT_PAR_DEFAUT: 'Default',
      STATUT_MODIFIE: 'Modified',
      STATUT_TELETRAVAIL: 'Remote',
      STATUT_NON_TRAVAILLE: 'Not worked',
      STATUT_DEJA_DECLARE: 'Already declared',
      STATUT_VALIDE: 'Validated',
      STATUT_CONGE: 'On leave',
      JOUR_TRAVAILLE: 'Working day',
      ENREGISTRER: 'Save',
      TOTAL_SEMAINE: 'Week total',
      SUR_N_JOURS: 'over {{count}} days',
      DECLARER_LA_SEMAINE_BTN: 'Declare the week',
      VALIDER_UNE_SEMAINE: 'Validate a week',
      VALIDATE_WEEK_TITLE: 'Validate a week',
      VALIDATE_WEEK_SUBTITLE: 'Quickly validate the time entered by your team',
      COLLABORATEURS: 'Collaborators',
      HEURES_A_VALIDER: 'Hours to validate',
      JOURS_A_VALIDER: 'Days to validate',
      ALERTES_CONTRAT: 'Contract alerts',
      TOUS_LES_COLLABORATEURS: 'All collaborators',
      AFFICHER_ALERTES_UNIQUEMENT: 'Show alerts only',
      COLLABORATEUR: 'Collaborator',
      CONTRAT_HEBDO: 'Contract (weekly)',
      FORFAIT_JOURS_LABEL: 'Fixed-days contract',
      A_VALIDER_CETTE_SEMAINE: 'To validate (this week)',
      CONFORME: 'Compliant',
      DEPASSEMENT: 'Exceeded',
      ALERTES_INFO_CONTRAT: 'Alerts indicate that the hours entered exceed the weekly hours defined in the contract.',
      TOUT_VALIDER: 'Validate all',
      VALIDER_LA_SELECTION: 'Validate selection',
      AUCUNE_DONNEE_A_VALIDER: 'No hours to validate for this period',
      AUCUN_COLLABORATEUR_SELECTIONNE: 'Please select at least one collaborator',
    },
    ALERTES: {
      LOADING_ALERTS: 'Loading alerts...',
      PLEASE_WAIT: 'Please wait',
      NO_ALERTS: 'No alerts',
      SENDER: 'Sender',
      RECIPIENT: 'Recipient',
      PERSON: 'Person',
      DIRECTION: 'Direction',
      DIRECTION_SENT: 'Outgoing',
      DIRECTION_RECEIVED: 'Incoming',
      ADMIN_DIRECTION_SENT: 'Sent',
      ADMIN_DIRECTION_RECEIVED: 'Received',
      MESSAGE: 'Message',
      DATE: 'Date',
      EMISSION_DATE: 'Emission date',
      READ_DATE: 'Read on',
      PROCESSED_DATE: 'Processed on',
      STATUS: 'Status',
      STATUS_UNREAD: 'Unread',
      STATUS_READ: 'Read',
      STATUS_PROCESSED: 'Processed',
      MARK_AS_READ: 'Mark as read',
      MARK_AS_PROCESSED: 'Mark as processed',
      VIEW_ALERT: 'View alert',
      ALERT_DETAILS: 'Alert details',
      FROM: 'From',
      FULL_MESSAGE: 'Full message',
      DISCLAIMER: 'Attention EmyeHR provides certain alerts, which are for informational purposes only, are not exhaustive, and do not engage the responsibility of the publisher.',
      LEGAL_NOTICE_LINK: 'Legal Notice — Time Tracking',
      LEGAL_NOTICE_TITLE: 'Scope of alerts and responsibility',
      LEGAL_NOTICE_SCOPE: 'The alerts available in this module are provided for informational purposes only and do not constitute an exhaustive list of all legal, collective agreement, or regulatory obligations applicable to working time.',
      LEGAL_NOTICE_EXHAUSTIVENESS: 'No guarantee of exhaustiveness',
      LEGAL_NOTICE_EXHAUSTIVENESS_TEXT: 'The alert system does not necessarily cover all rules from the Labor Code, applicable collective agreements, company agreements, or any other specific arrangements of the using company. Situations not detected by alerts may nevertheless constitute breaches of applicable rules.',
      LEGAL_NOTICE_RESPONSIBILITY: 'Responsibility of the using company',
      LEGAL_NOTICE_RESPONSIBILITY_TEXT: 'It is the responsibility of the using company to ensure, at its own risk, compliance with all legal and collective provisions applicable to its employees. The solution provider cannot be held liable for any breach resulting from the failure to trigger an alert or an incomplete alert.',
      LEGAL_NOTICE_RECOMMENDATION: 'Recommendation',
      LEGAL_NOTICE_RECOMMENDATION_TEXT: 'We recommend that the using company supplement automated monitoring with its own internal controls and, where appropriate, consult legal counsel specializing in labor law for any questions regarding compliance with its working time management practices.',
      LEGAL_NOTICE_FOOTER: 'The alerts provided are indicative and not exhaustive. Regulatory compliance is the sole responsibility of the using company.',
      CLOSE: 'Close',
    }
  }
}

// Export the translations
export default locale.data;
